// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_1d5Oo","donate":"_3uA1v","become-supporter-container":"_3ssrm","become-supporter-header":"_2OiYX","become-supporter-paragraph":"A9NAs","become-supporter-text":"_2AwfJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Supporters/BecomeSupporter.scss
// module id = ./src/components/Supporters/BecomeSupporter.scss
// module chunks = 5